export function getOptimizedImageUrl(url, width = 800, quality = 80) {
  // Supabase Image Transformation is a paid feature. 
  // Returning the original URL to ensure images load correctly on all plans.
  return url;
}
